import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

import ClearIcon from '@mui/icons-material/Clear';

import { Controller } from 'react-hook-form';
export default function Search({ control, handleSubmit, clearAction }) {
  return (
    <FormControl sx={{ width: { xs: '100%', md: '100%' } }} variant="outlined">
      <Controller
        name="new_search_terms"
        control={control}
        defaultValue=""
        render={({ field }) => (
          <OutlinedInput
            {...field}
            size="small"
            id="search"
            placeholder="Search…"
            sx={{ flexGrow: 1, borderRadius: 0, backgroundColor: '#F6F8FB', border: '0px', height: '40px' }}
            startAdornment={
              <InputAdornment position="start" sx={{ color: 'text.primary' }}>
                <SearchRoundedIcon fontSize="small" />
              </InputAdornment>
            }
            endAdornment={
              field.value ? (
                <InputAdornment position="end">
                    <IconButton type="button" sx={{ p: '10px' }} aria-label="search" onClick={() => {handleSubmit(clearAction)();}}>
                        <SearchIcon />
                    </IconButton>
                  <ClearIcon fontSize='small' sx={{ cursor: 'pointer' }}
                    onClick={() => { field.onChange(''); handleSubmit(clearAction)(); }} />
                </InputAdornment>

              ) : null
            }
            inputProps={{
              'aria-label': 'search',
            }} />
        )}

      />
    </FormControl>
  );
}
